import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Touchable from '../../Atoms/Touchable'
import { Text } from '../../Atoms/Typography'

import theme from '../../../styles/theme'

const Container = styled(View)`
  align-items: center;
  justify-content: center;
  flex-direction: row;
`

const CircularButton = styled(Touchable)`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: ${props => props.disabled ? theme.colours.grey : theme.colours.primary};
  border-width: 0;
`

const TextContainer = styled(View)`
  align-items: center;
  justify-content: center;
`

const ValueTextContainer = styled(TextContainer)`
  width: 80px;
`
const PercentageContainer = styled(View)`
  margin-right: ${theme.gutterUnit}px;
`

class ValueChanger extends PureComponent {
  render () {
    const { value, formatValue, onDecrement, onIncrement, min, max, percentageChange, enableChanges } = this.props
    const minDisabled = !enableChanges || (min != null && value === min)
    const maxDisabled = !enableChanges || (max != null && value === max)
    return (
      <Container>
        {enableChanges && (
          <CircularButton
            disabled={minDisabled} onPress={() => {
              if (!minDisabled) onDecrement(value)
            }}
          >
            <TextContainer>
              <Text white size='l' medium>-</Text>
            </TextContainer>
          </CircularButton>
        )}
        <ValueTextContainer>
          <Text size='xs' medium>{formatValue(value)}</Text>
        </ValueTextContainer>
        {percentageChange && (
          <PercentageContainer>
            {percentageChange()}
          </PercentageContainer>
        )}
        {enableChanges && (
          <CircularButton
            disabled={maxDisabled} onPress={() => {
              if (!maxDisabled) onIncrement(value)
            }}
          >
            <TextContainer>
              <Text white size='l' medium>+</Text>
            </TextContainer>
          </CircularButton>
        )}
      </Container>
    )
  }
}

export default ValueChanger
